import { dates, empty } from './utils.js';
const create = (policy) => ({
    name: policy.name,
    changable: policy.changable ?? true,
    cookies: policy.cookies ?? [],
    onAllow: policy.onAllow ?? empty,
    onDeny: policy.onDeny ?? empty,
    allowExpires: policy.allowExpires ?? dates.never,
    denyExpires: policy.denyExpires ?? dates.months(3),
    allowed: policy.defaultValue,
    expiresAt: dates.yesterday()
});
const load = (policy, database) => ({
    ...policy,
    changable: policy.changable ?? true,
    cookies: policy.cookies ?? [],
    onAllow: policy.onAllow ?? empty,
    onDeny: policy.onDeny ?? empty,
    allowExpires: policy.allowExpires ?? dates.never,
    denyExpires: policy.denyExpires ?? dates.months(3),
    allowed: database.allowed,
    expiresAt: database.expiresAt ? new Date(database.expiresAt) : null
});
export const searialize = (policy) => ({
    name: policy.name,
    allowed: policy.allowed,
    expiresAt: policy.expiresAt?.toISOString() ?? null
});
export const deserialize = (policy, database) => policy.name in database ? load(policy, database[policy.name]) : create(policy);
